(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };
    }

    connectedCallback() {
      this.section = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.section) return;

      this.stickyType = this.getAttribute('data-sticky-type') || 'none';
      this.isAlwaysSticky =
        this.stickyType === 'always' ||
        this.stickyType === 'reduce-logo-size';

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();

      if (this.isAlwaysSticky) {
        this.section.classList.add('shopify-section-header-sticky');
      }

      this.updateScrolledState(this.currentScrollTop);

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    }

    setHeaderHeight() {
      if (!this.section) return;
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.section.offsetHeight}px`
      );
    }

    updateScrolledState(scrollTop) {
      if (!this.section) return;

      if (scrollTop > 20) {
        this.section.classList.add('scrolled-past-header');
      } else {
        this.section.classList.remove('scrolled-past-header');
      }
    }

    onScroll() {
      if (!this.section) return;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        0;

      this.updateScrolledState(scrollTop);

      if (this.isAlwaysSticky) {
        this.section.classList.add('shopify-section-header-sticky');
        this.section.classList.remove('shopify-section-header-hidden');
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.stickyType === 'on-scroll-up') {
        if (scrollTop <= 20) {
          this.reset();
        } else if (scrollTop > this.currentScrollTop) {
          this.hide();
        } else if (scrollTop < this.currentScrollTop && !this.preventReveal) {
          this.reveal();
        }

        if (this.preventReveal) {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (!this.section) return;

      this.section.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.section) return;

      this.section.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.section.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (!this.section) return;

      this.section.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

      if (this.isAlwaysSticky) {
        this.section.classList.add('shopify-section-header-sticky');
      }
    }

    closeMenuDisclosure() {
      const disclosures = this.section.querySelectorAll('header-menu');
      disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      const searchModal = this.section.querySelector('details-modal');
      if (searchModal && typeof searchModal.close === 'function') {
        searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
